import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { AgentConceptCard } from './AgentConceptCard';
import { useAgentConceptCards } from './useAgentConceptCards';

// TODO: cleanup with cp_annotation_createproject_agent ff

/** One collapsed card per step 2 concept group. Groups are added and removed in step 2. */
export const AgentConceptCards = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const cards = useAgentConceptCards();

  return (
    <Box id="agent-concept-cards">
      <Typography variant="subtitle1" sx={{ mb: theme.spacing(4) }}>
        {formatMessage({ id: 'createProjectWizard.step.annotationAgent.concepts.title' })}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(3) }}>
        {cards.map(({ conceptGroupId, concept, alias, attributeLabels }) => (
          <AgentConceptCard
            key={conceptGroupId}
            conceptGroupId={conceptGroupId}
            concept={concept}
            alias={alias}
            attributeLabels={attributeLabels}
          />
        ))}
      </Box>
    </Box>
  );
};
